import React, { Component } from 'react'
import ClassesPV from './ClassesPV'
import AuthA from '../../store/actions/AuthA'

import axios from 'axios'
import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import {connect} from 'react-redux'

const _ = {
  sortBy: sortBy,
  find: find,
  isEmpty: isEmpty
}

class ClassesPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sections: [],
      column: null,
      direction: null,
      schoolYears: [],
      currentSchoolYear: '',
      schoolYearId: '',
      sectionId: '',
      loaded: false,
      sectionSubjects: []
    };
    this.getSections = this.getSections.bind(this);
    this.getSectionSubjects = this.getSectionSubjects.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }

  getSections(isSectionEmpty, sectionId) {
    axios.get(process.env.REACT_APP_URL+'/sections/user?schoolYearId='+this.state.schoolYearId+'&userType='+this.props.userType+'&teacherId='+this.props.userId)
    .then(response => {
      this.setState({ sections: response.data, sectionId: sectionId, loaded: true }, () => {
        if(!isSectionEmpty) {
          this.getSectionSubjects(sectionId);
        }
      });
    });
  }

  getSectionSubjects(sectionId) {
    axios.get(process.env.REACT_APP_URL+'/sectionSubjects?filter[where][active]=true&filter[include]=subject&filter[include]=teacher&filter[include]=details&filter[where][sectionId]='+sectionId)
    .then(response => {
      console.log(response.data);
      this.setState({ sectionSubjects: response.data });
    });
  }

  getSchoolYears(isSectionEmpty, sectionId) {
    axios.get(process.env.REACT_APP_URL+'/schoolyears?filter[where][active]=true')
    .then(response => {
      const currentSchoolYear = _.find(response.data, {
        isCurrent: true
      });
      this.setState({
        schoolYears: response.data,
        schoolYearId: currentSchoolYear.schoolYearId,
        currentSchoolYear: currentSchoolYear
      }, function(){
        if(isSectionEmpty) {
          this.getSections(isSectionEmpty, sectionId);
        } else {
          this.getSections(isSectionEmpty, sectionId);
          // this.getSectionSubjects(sectionId);
        }

      });
    });
  }

  handleSort(clickedColumn) {
    const { column, sectionSubjects, direction } = this.state
    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        sectionSubjects: _.sortBy(sectionSubjects, [clickedColumn]),
        direction: 'ascending',
      })
      return
    }
    this.setState({
      sectionSubjects: sectionSubjects.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handleChange = (e, { name, value }) => {
    if (name === 'sectionId') {
      // this.setState({[name]: value}, () => this.getSectionSubjects(value))
      this.props.history.push('/classes/' + value);
    } else {
      this.setState({ [name]: value }, () => this.getSections(true, ''))
    }

  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'School Setup / Classes'});
    const sectionId = this.props.match.params.sectionId;
    if(_.isEmpty(this.props.match.params)) {
      this.getSchoolYears(true, '');
    } else {
      this.getSchoolYears(false, sectionId);
    }
  }

  componentWillReceiveProps(newProps) {
    const sectionId = newProps.match.params.sectionId;
    if(_.isEmpty(newProps.match.params)) {
      this.getSchoolYears(true, '');
    } else {
      this.getSchoolYears(false, sectionId);
    }
  }

  render() {
    return (
      <ClassesPV
        auth={this.props.auth}
        userType={this.props.userType}
        column={this.state.column}
        direction={this.state.direction}
        sectionId={this.state.sectionId}
        sections={this.state.sections}
        sectionSubjects={this.state.sectionSubjects}
        schoolYears={this.state.schoolYears}
        currentSchoolYear={this.state.currentSchoolYear}
        schoolYearId={this.state.schoolYearId}
        loaded={this.state.loaded}
        handleSort={this.handleSort}
        handleChange={this.handleChange}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    userId: state.AuthR.userId,
    userType: state.AuthR.userType
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassesPC);
